import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { initNative } from './native';
import { applyGrayscale, isGrayscale } from './utils/grayscale';

initNative();
applyGrayscale(isGrayscale());

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  componentDidCatch(error) {
    // ChunkLoadError = stale cache after a new deploy — just reload once
    if (error?.name === 'ChunkLoadError' || error?.message?.includes('Loading chunk')) {
      const reloaded = sessionStorage.getItem('chunk_reload');
      if (!reloaded) {
        sessionStorage.setItem('chunk_reload', '1');
        window.location.reload();
        return;
      }
    }
    this.setState({ error });
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 40, fontFamily: 'sans-serif', background: '#fff' }}>
          <h2 style={{ color: '#c00' }}>Something went wrong</h2>
          <p style={{ color: '#666', fontSize: 14 }}>Try refreshing the page. If the problem persists, contact support.</p>
          <button onClick={() => { sessionStorage.clear(); window.location.reload(); }}
            style={{ marginTop: 16, padding: '8px 20px', background: '#1e3a5f', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14 }}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
